import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

import { Button, Card, Heading, Space } from '@/components'
import { Routes } from '@/constants'
import { useCurrentUserContext } from '@/contexts/CurrentUserContext'
import usePermissions from '@/hooks/usePermissions'

import { NextPageWithLayout } from './_app'

const Custom404: NextPageWithLayout = () => {
  const userContext = useCurrentUserContext()
  const { isOwner } = usePermissions()
  const { replace } = useRouter()

  const isLoggedIn = userContext?.currentUser?.me?.email

  const redirectToLearningCommunities = (): void => {
    replace(`/${Routes.LEARNING_COMMUNITIES}`)
  }

  const redirectToLearningPath = (): void => {
    replace('/')
  }

  const redirectToLogin = (): void => {
    replace(`/${Routes.LOGIN}`)
  }

  const redirectToColeap = (): void => {
    window.location.href = process?.env?.NEXT_PUBLIC_WEBSITE_URL ?? ''
  }

  return (
    <div className="flex h-screen items-center">
      <Head>
        <title>The page you were looking for doesn't exist | 404</title>
      </Head>

      <div className="mx-auto sm:w-8/12 md:w-6/12 lg:w-4/12">
        <Card justify="center">
          <Heading level={1} variant={TextStyle => TextStyle.MEDIUM_2XL_NORMAL}>
            This page does not exist
          </Heading>

          <Space y={10} />

          {isLoggedIn ? (
            <>
              {isOwner ? (
                <Button variant="primary" block onClick={redirectToLearningCommunities}>
                  Manage your learning communities
                </Button>
              ) : (
                <Button variant="primary" block onClick={redirectToLearningPath}>
                  Check your learning path
                </Button>
              )}
            </>
          ) : (
            <Button variant="primary" block onClick={redirectToLogin}>
              Sign in
            </Button>
          )}

          <Space y={4} />

          <Button block onClick={redirectToColeap}>
            Visit Coleap
          </Button>
        </Card>
      </div>
    </div>
  )
}

Custom404.getLayout = function getLayout(page: JSX.Element) {
  return page
}

export default Custom404
